// extracted by mini-css-extract-plugin
export var readonly = "_hu-1";
export var star = "_hu-0";